import {HOMEAWAY, VRBO, BOOKABACH, STAYZ, CTA_LINK_HOMEAWAY,
    CTA_LINK_VRBO, CTA_BUTTON_TEXT, HOMEAWAY_SITE, RATING_TEXT} from '../banner-defaults';

function getBrandName(travelerApp) {
    switch (travelerApp) {
        case 'ha' :
        case 'homeaway' :
            return HOMEAWAY;
        case 'sz' :
        case 'stayz' :
            return STAYZ;
        case 'bab' :
        case 'bookabach' :
            return BOOKABACH;
        case 'vrbo' :
            return VRBO;
        default:
            return VRBO;
    }
}

function getBrand(fullLocale, locale) {
    const homeawayLocales = ['fr_fr', 'de_de'];
    const heritageBrandLocales = ['en_nz', 'en_au'];
    let brand = 'VRBO';
    if (homeawayLocales.indexOf(locale.toLowerCase()) > -1) {
        brand = 'HA';
    } else if (heritageBrandLocales.indexOf(locale.toLowerCase()) > -1) {
        let localeChunks = fullLocale.split('_');
        brand = localeChunks[localeChunks.length - 1];
        brand = (brand === 'HA') ? 'VRBO' : brand;
    }
    return getBrandName(brand.toLowerCase());
}

function getDownloadLinkBase(brandName) {
    return brandName.toLowerCase() === VRBO.toLowerCase() ? CTA_LINK_VRBO : CTA_LINK_HOMEAWAY;
}

function getDownloadLink(ctaLink, brandName, hav, xdid) {
    const downloadLinkBase = ctaLink ? ctaLink : getDownloadLinkBase(brandName);
    return `${downloadLinkBase}?hav=${hav}&source_visitor_id=${hav}&source_xdid=${xdid}`;
}

function getImgUrl(site) {
    return `https://csvcus.homeaway.com/rsrcs/cdn-logos/5.4.0/sitename/${site.toLocaleLowerCase()}/web/app-icon-rounded.png`;
}

function getSite(brandName) {
    return brandName === HOMEAWAY ? HOMEAWAY_SITE : brandName.toLowerCase();
}

function getButtonLabel(label) {
    return label ? label : CTA_BUTTON_TEXT;
}

const appBannerCtaLinks = {
    'vrbo': {
        'inbox': 'https://t.vrbo.io/rE2P1y0qQ3',
        'mytrips': 'https://t.vrbo.io/tpErRkuBt5',
        'homepage': 'https://t.vrbo.io/50uyc7ONY6',
        'serp': 'https://t.vrbo.io/vzOOWqKPq7'
    },
    'homeaway': {
        'inbox': 'https://t.hmwy.io/FERmK3HrD3',
        'mytrips': 'https://t.hmwy.io/EpaEUzEBt5',
        'homepage': 'https://t.hmwy.io/218P4iYNY6',
        'serp': 'https://t.hmwy.io/wwKd6WUPq7 '
    },
    'stayz': {
        'inbox': 'https://t.hmwy.io/FERmK3HrD3',
        'mytrips': 'https://t.hmwy.io/EpaEUzEBt5',
        'homepage': 'https://t.hmwy.io/218P4iYNY6',
        'serp': 'https://t.hmwy.io/wwKd6WUPq7 '
    },
    'bookabach': {
        'inbox': 'https://t.hmwy.io/FERmK3HrD3',
        'mytrips': 'https://t.hmwy.io/EpaEUzEBt5',
        'homepage': 'https://t.hmwy.io/218P4iYNY6',
        'serp': 'https://t.hmwy.io/wwKd6WUPq7 '
    }
};

const appModalCtaLinks = {
    'vrbo': {
        'mytrips': 'https://t.vrbo.io/M19crbFV08',
        'confirmation': 'https://t.vrbo.io/CMAnLirhAab',
        'confirmation-above-share-trip': 'https://t.vrbo.io/Qdawaa6Dxbb',
        'confirmation-below-share-trip': 'https://t.vrbo.io/Qdawaa6Dxbb',
        'homepage': 'https://t.vrbo.io/TQ4hjH5t6bb'
    },
    'homeaway': {
        'mytrips': 'https://t.hmwy.io/PftghSQV08',
        'confirmation': 'https://t.hmwy.io/eCqNC24aDab',
        'confirmation-above-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'confirmation-below-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'homepage': 'https://t.hmwy.io/woYmnjhu6bb'
    },
    'stayz': {
        'mytrips': 'https://t.hmwy.io/PftghSQV08',
        'confirmation': 'https://t.hmwy.io/eCqNC24aDab',
        'confirmation-above-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'confirmation-below-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'homepage': 'https://t.hmwy.io/woYmnjhu6bb'
    },
    'bookabach': {
        'mytrips': 'https://t.hmwy.io/PftghSQV08',
        'confirmation': 'https://t.hmwy.io/eCqNC24aDab',
        'confirmation-above-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'confirmation-below-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'homepage': 'https://t.hmwy.io/woYmnjhu6bb'
    }
};

const BOOKINGS = 'bookings';
const CONFIRMATION = 'confirmation';
const HOMEAWAY_AS_DISPLAY_STRING = 'HomeAway';
const HOMEPAGE = 'homepage';
const INBOX = 'inbox';
const MY_TRIPS = 'mytrips';
const SERP = 'serp';
const STAYUI = 'stayUi';
const VRBO_AS_DISPLAY_STRING = 'Vrbo';
const RATINGS = {
    'android': '13.5k',
    'ios': '592.8k'
};

const STARS = {
    'android': '4.5',
    'ios': '4.8'
};

export {
    BOOKINGS,
    CONFIRMATION,
    HOMEAWAY_AS_DISPLAY_STRING,
    HOMEPAGE,
    INBOX,
    MY_TRIPS,
    RATING_TEXT,
    RATINGS,
    SERP,
    STARS,
    STAYUI,
    VRBO_AS_DISPLAY_STRING,
    appBannerCtaLinks,
    appModalCtaLinks,
    getButtonLabel,
    getBrand,
    getBrandName,
    getDownloadLinkBase,
    getDownloadLink,
    getImgUrl,
    getSite
};
